import Button from '@basic/Button';
import { useTranslation } from 'react-i18next';

interface Props {
  onReLogin: () => void;
}

const SessionLostNotice = ({ onReLogin }: Props) => {
  const { t } = useTranslation();
  return (
    <div
      data-testid='session-lost-notice'
      className='w-full h-dvh flex items-center justify-center p-md'
    >
      <div className='max-w-md w-full flex flex-col gap-md items-center text-center'>
        <h2 className='H6'>{t('domains.auth.sessionLost.title')}</h2>
        <p className='P2R'>{t('domains.auth.sessionLost.message')}</p>
        <Button onClick={onReLogin} fitContent data-testid='session-lost-sign-in-again'>
          {t('domains.auth.sessionLost.signInAgain')}
        </Button>
      </div>
    </div>
  );
};

export default SessionLostNotice;
